import React from 'react';

const ReviewCard = ({ name, rating, comment }) => {
  return (
    <div className="bg-white shadow-md rounded-lg p-6">
      <div className="text-yellow-400 text-lg mb-2">
        {'★'.repeat(rating)}{'☆'.repeat(5 - rating)}
      </div>
      <p className="text-gray-800 italic mb-4">"{comment}"</p>
      <p className="text-sm font-semibold text-gray-600">– {name}</p>
    </div>
  );
};

export default ReviewCard;
